export enum NodeLabelExistError {
  PROCESS_GATE = "Process gate name already exists",
  FARM_GATE = "Farm gate name already exists",
  PROCESSING = "Processing name already exists",
  PACKAGING = "Packaging name already exists",
  INTERNAL_TRANSPORT = "Internal transport name already exists",
  INTERNAL_STORAGE = "Internal storage name already exists",
  INGREDIENTS = "Ingredients name already exists",
  EXTERNAL_TRANSPORT = "External transport name already exists",
  EXTERNAL_WAREHOUSE = "External warehouse name already exists"
}
